import type { Connection } from "@/lib/types/unified";
import { z } from "zod";
import { logger } from "@/lib/logger";

const ConnectionsResponseSchema = z.object({
  connections: z.array(z.any()),
});

export async function fetchConnections(token?: string): Promise<Connection[]> {
  try {
    const response = await fetch("/api/connections/connections", {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        ...(token ? { Authorization: `Bearer ${token}` } : {}),
      },
    });

    if (!response.ok) {
      throw new Error("Failed to fetch connections");
    }

    const data = await response.json();

    try {
      const validatedData = ConnectionsResponseSchema.parse(data);
      return validatedData.connections || [];
    } catch (validationError) {
      logger.error("Response validation failed", validationError);
      throw new Error("Invalid response structure from connections API");
    }
  } catch (error) {
    logger.error("Error fetching connections", error);
    throw new Error("Failed to fetch connections");
  }
}
